import { thisOscarsYear } from '../config/constants';
import { CurrentUserResourceType } from '../resources/Auth/CurrentUser';
import { SingleLanguageCopyType } from '../assets/copy';

let getWrapMessage = (
  currentUser: CurrentUserResourceType,
  copy: SingleLanguageCopyType,
) => {
  let ballotData = currentUser.ballotData;
  let entries = Object.entries(ballotData ?? {});
  let thisYear = String(thisOscarsYear);
  let completedThisYear = Boolean(ballotData?.[thisYear]?.isCompleted);
  let startedThisYear = Boolean(ballotData?.[thisYear]?.isStarted);

  if (completedThisYear) {
    let completedYears = entries
      .filter(([, v]) => v.isCompleted)
      .map(([year]) => Number(year))
      .sort((a, b) => a - b);
    let totalCompleted = completedYears.length;

    if (totalCompleted <= 1) return copy.wrapCongratsFirstTime;

    let streak = 1;
    for (let i = completedYears.length - 2; i >= 0; i--) {
      if (completedYears[i] === completedYears[i + 1] - 1) streak++;
      else break;
    }

    if (streak >= totalCompleted)
      return copy.wrapThanksStreak({ count: totalCompleted });
    return copy.wrapThanksNoStreak({ count: totalCompleted });
  }

  let hasPlayedBefore = entries.some(
    ([year, v]) => year !== thisYear && (v.isCompleted || v.isStarted),
  );

  if (startedThisYear && hasPlayedBefore) return copy.wrapHopeToSeeBallot;
  if (hasPlayedBefore) return copy.wrapHopeToSeeYouAgain;
  return copy.wrapHopeToSeeYou;
};

export default getWrapMessage;
